.timeComparison {
  .widgetContainer {
    @media (--md-up) {
      .widget-container {
        position: relative;

        &::before {
          position: absolute;
          top: -3.5rem;
          left: 50%;
          width: 1px;
          height: calc(100% + 3.5rem);
          content: "";
          border: 1px solid var(--gray-400);
          transform: translateX(-50%);
        }
      }
    }
  }
}

.timePeriodIcon {
  position: relative;
  top: -1px;
  margin-right: 0.5rem;
}

.toolbar {
  display: flex;

  @media (--sm-down) {
    flex-wrap: wrap;

    > *:not(:global(.react-datepicker__tab-loop)) {
      display: block;
      width: 50%;
    }

    > * > :global(.btn-secondary-grayish) {
      width: 100%;
    }
  }

  :global(.share-button) {
    margin-left: auto;
  }
}
